import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Row, Col } from "reactstrap";

const links = [
  { to: "/dashboard", label: "Home", icon: "/home.png" },
  {
    to: "/daily_transactions",
    label: "Transactions",
    icon: "/transactions.png",
  },
  // { to: "/refund", label: "Refund", icon: "/refund.png" },
  { to: "/servicelogs", label: "Service Logs", icon: "/history.png" },
  { to: "/upload_data", label: "Upload Data", icon: "/upload.png" },
];

const BreadCrumb = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  const handleItemClick = (to) => {
    setActiveLink(to);
  };

  return (
    <Row className="justify-content-between text-center align-items-center">
      <Col xs={12} md={10} className="d-flex gap-5 mt-4">
        {links.map(({ to, label, icon }) => (
          <div key={to} className={`text-center`}>
            <Link to={to} onClick={() => handleItemClick(to)}>
              <img src={icon} width="40px" height="40px" alt={label} />
              <p
                className={`text-white pt-2 ${
                  to === activeLink ? "fw-bold" : ""
                }`}
              >
                {label}
                {to === activeLink && (
                  <p style={{ backgroundColor: "white", height: "1px" }} />
                )}
              </p>
            </Link>
          </div>
        ))}
      </Col>
      <Col xs={12} md={2} className="text-center mt-4 mt-md-0">
        <Link to="/logout" className="cursor-pointer">
          <img src={`${process.env.PUBLIC_URL}/logout.png`} width="40px" height="40px" alt="logout" />
          <span className="align-middle text-white" data-key="t-logout">
            Logout
          </span>
        </Link>
      </Col>
    </Row>
  );
};

export default BreadCrumb;
